import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { getAppSocket } from '../lib/wesSocket';

interface AlertResponse {
  alerts: Array<{
    id: string;
  }>;
}

const AlertsButton: React.FC = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let mounted = true;
    const dismissedAlertsKey = 'dismissed-system-alerts';
    let refreshTimer: number | null = null;

    const getDismissedAlerts = () => {
      try {
        const stored = localStorage.getItem(dismissedAlertsKey);
        const parsed = stored ? JSON.parse(stored) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        console.warn('No se pudieron cargar alertas descartadas:', error);
        return [];
      }
    };

    const fetchAlerts = async () => {
      try {
        const { data } = await axios.get<AlertResponse>('/api/dashboard/alerts');
        if (!mounted) return;
        const dismissedIds = getDismissedAlerts();
        const visibleAlerts = (data?.alerts || []).filter(
          (alert) => !dismissedIds.includes(alert.id)
        );
        setCount(visibleAlerts.length);
      } catch (error) {
        console.error('Error loading alerts count:', error);
      }
    };

    fetchAlerts();

    const scheduleRefresh = () => {
      if (refreshTimer) window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(() => {
        fetchAlerts();
      }, 350);
    };

    const socket = getAppSocket();
    socket.on('area:update', scheduleRefresh);
    socket.on('connect', scheduleRefresh);

    return () => {
      mounted = false;
      if (refreshTimer) window.clearTimeout(refreshTimer);
      socket.off('area:update', scheduleRefresh);
      socket.off('connect', scheduleRefresh);
    };
  }, []);

  return (
    <NavLink
      to="/alerts"
      className="relative cursor-pointer items-center justify-center gap-2 whitespace-nowrap text-sm font-medium disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border active:scale-[0.97] bg-card shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 px-4 py-2 has-[>svg]:px-3 hidden size-8 text-muted-foreground md:flex rounded-full transition-transform duration-200"
    >
      <ExclamationTriangleIcon className="h-4 w-4" />
      {count > 0 && (
        <span className="absolute -top-1 -right-1 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-red-500 px-1 text-xs font-semibold text-white">
          +{count}
        </span>
      )}
    </NavLink>
  );
};

export default AlertsButton;
